import React from "react"
import styled from "styled-components"

export const PageContent = styled.div`
  position: relative;
  margin: 0 auto;
`
